<template src="./individual-omr-result.html"></template>

<script>
import quizService from "../../../services/quiz-service";
import appHeader from "../../../../shared-module/components/app-header/app-header.vue";

export default {
  name: "app-individual-omr-result",
  components: {
    "app-header": appHeader,
  },
  data() {
    return {
      resultId: "",
      result: null,
      isPageLoading: true,
      uploadImgPopUp: false,
      selectedImage: "",
      filter: "all",
    };
  },
  computed: {
    quizName() {
      return (this.result && this.result.quiz && this.result.quiz.name) || "OMR Quiz";
    },
    score() {
      return (this.result && this.result.score) || {};
    },
    gradedQuestions() {
      if (!this.result) return [];
      if (this.result.graded_questions && this.result.graded_questions.length) {
        return this.result.graded_questions;
      }
      const snapshot = this.result.answers_snapshot || {};
      return snapshot.graded || [];
    },
    filterCounts() {
      const counts = { all: this.gradedQuestions.length, wrong: 0, empty: 0 };
      this.gradedQuestions.forEach((item) => {
        const status = this.questionStatusClass(item);
        if (status === "incorrect" || status === "multi") counts.wrong += 1;
        if (status === "empty") counts.empty += 1;
      });
      return counts;
    },
    filteredQuestions() {
      if (this.filter === "all") return this.gradedQuestions;
      if (this.filter === "wrong") {
        return this.gradedQuestions.filter((item) => {
          const status = this.questionStatusClass(item);
          return status === "incorrect" || status === "multi";
        });
      }
      return this.gradedQuestions.filter((item) => this.questionStatusClass(item) === "empty");
    },
    sheetColumns() {
      const total = Math.max(
        this.score.total || 0,
        ...this.gradedQuestions.map((item) => Number(item.question_no) || 0),
      );
      const columns = [];
      for (let start = 1; start <= total; start += 50) {
        const end = Math.min(start + 49, total);
        columns.push({
          start,
          end,
          questions: this.filteredQuestions
            .filter((item) => item.question_no >= start && item.question_no <= end)
            .sort((a, b) => a.question_no - b.question_no),
        });
      }
      return columns;
    },
    insights() {
      const total = this.score.total || this.gradedQuestions.length || 0;
      const attempted = total - (this.score.unmarked || 0);
      const attemptRate = total > 0 ? (attempted / total) * 100 : 0;
      const passing = Number((this.result && this.result.quiz && this.result.quiz.passing_percentage) || 0);
      const accuracy = Number(this.score.correct_percentage || 0);
      const passed = (this.result && this.result.result === true) || accuracy >= passing;
      return {
        attemptNumber: (this.result && this.result.attempt_number) || 1,
        attempted,
        total,
        attemptRate,
        passing,
        accuracy,
        passed,
        wrong: this.filterCounts.wrong,
        empty: this.filterCounts.empty,
      };
    },
    focusMessage() {
      if (!this.insights) return "";
      if (this.insights.empty > this.insights.wrong && this.insights.empty > 0) {
        return this.insights.empty + " unmarked — student left bubbles blank.";
      }
      if (this.insights.wrong > 0) {
        return this.insights.wrong + " incorrect marks — review wrong filter for coaching.";
      }
      if (this.insights.passed) return "Clean attempt — marked answers align with the key.";
      return "Below pass threshold — consider follow-up with this student.";
    },
  },
  mounted() {
    if (this.$route.query.resultId) {
      this.resultId = this.$route.query.resultId;
      this.loadResult();
    } else {
      this.isPageLoading = false;
      this.$toast.error("Result id is missing");
    }
  },
  methods: {
    async loadResult() {
      this.isPageLoading = true;
      try {
        const response = await quizService.getResultsByResultIdForOmr(this.resultId);
        this.result = response.data.data.result;
      } catch (error) {
        console.error(error);
        this.$toast.error("OMR result not found");
      } finally {
        this.isPageLoading = false;
      }
    },
    backToMainResults() {
      window.history.back();
    },
    showImage(image) {
      this.selectedImage = image;
      this.uploadImgPopUp = true;
    },
    setFilter(id) {
      this.filter = id;
    },
    formatPercent(value) {
      const n = Number(value);
      if (!Number.isFinite(n)) return "0.0";
      return n.toFixed(1);
    },
    displayMarked(marked) {
      if (!marked) return "—";
      if (marked === "MULTI") return "Multiple";
      return marked;
    },
    questionStatusLabel(item) {
      if (item.is_multi) return "Multiple";
      if (item.is_skipped || !item.marked_answer) return "Unmarked";
      return item.is_correct ? "Correct" : "Wrong";
    },
    questionStatusClass(item) {
      if (item.is_multi) return "multi";
      if (item.is_skipped || !item.marked_answer) return "empty";
      return item.is_correct ? "correct" : "incorrect";
    },
    bubbleClass(item, opt) {
      const marked = String(item.marked_answer || "").toUpperCase();
      const key = String(item.correct_option || "").toUpperCase();
      const isMarked = marked === opt;
      const isKey = key === opt;
      if (isMarked && isKey) return "hit";
      if (isMarked) return "miss";
      if (isKey) return "key-only";
      return "";
    },
  },
};
</script>

<style src="./individual-omr-result.css" scoped></style>
